<script lang="ts" setup>
import { goChatMateList } from "@/components/mobile/chat/chatUtils";
import UserAvatar from "@/components/UserAvatar.vue";
import { timeAgo } from "@/modules/common";
import { ChatSessionItem, useChatSession } from "@/stores/chatSession";
import { useRouter } from "vue-router";

// Props & Emit

const props = defineProps<ChatSessionItem & { isCollapsed?: boolean }>();
const chatSessionStore = useChatSession();

const router = useRouter();
const onClick = () => {
  goChatMateList(props.uuid);
};

const onRecentChatClick = () => {
  chatSessionStore.goChat(router, props.uuid, props.id);
};
</script>
<template>
  <div
    :class="{
      flex: props.isCollapsed,
      'grid grid-cols-[auto_1fr_auto] gap-2': !props.isCollapsed,
    }"
    class="p-2 border-b justify-between cursor-pointer"
    @click="onClick"
  >
    <div class="indicator">
      <span
        v-if="unread && unread > 0"
        class="indicator-item badge badge-primary badge-sm"
      >
        {{ unread }}
      </span>
      <user-avatar
        :avatar-url="avatarUrl"
        class="h-16 shrink-0 pointer-events-none"
      />
    </div>
    <div
      :class="{
        hidden: props.isCollapsed,
      }"
      class="flex flex-col flex-grow overflow-hidden text-base-content/50 justify-between"
    >
      <div class="flex flex-col w-full">
        <div class="text-base-content">{{ title }}</div>
        <div class="line-clamp-1">{{ content }}</div>
      </div>
      <div class="flex gap-1 text-xs">
        <div class="text-base-content/50">{{ timeAgo(time) }}</div>
      </div>
    </div>
    <div
      :class="{
        hidden: props.isCollapsed,
      }"
      class="flex flex-col justify-between"
    >
      <button
        class="btn btn-xs text-base-content/50"
        @click="
          $event.stopPropagation();
          onClick();
        "
      >
        {{ $t("Buttons.all") }}
      </button>
      <button
        class="btn btn-outline btn-xs text-base-content/50"
        @click="
          $event.stopPropagation();
          onRecentChatClick();
        "
      >
        {{ $t("Buttons.recentChat") }}
      </button>
    </div>
  </div>
</template>
